// @flow
import * as React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

// Score color bands (locked from the design deck): >=90 green, 75-89 amber, <75 red.
export const scoreColor = (score?: number | null): string => {
  const s = score ?? 0;
  return s >= 90 ? '#0DBC83' : s >= 75 ? '#EB9C15' : '#F14E42';
};

// The 3 rubric categories in display order (exact strings).
export const QA_CATEGORIES = [
  'Mandatory Compliance',
  'Fact Finding & Needs Analysis',
  'Enrollment & Soft Skills',
];

// Solid-ring score gauge (Option A from the deck).
export const QaScoreRing = ({
  score, size = 130, thickness = 4, label = 'Average score',
}: { score?: number | null; size?: number; thickness?: number; label?: string }) => {
  const value = Math.round(score ?? 0);
  const color = scoreColor(score);
  return (
    <Box sx={{ position: 'relative', height: size, width: size }}>
      <CircularProgress variant={'determinate'} value={100} size={size} thickness={thickness}
                        sx={{ position: 'absolute', color, opacity: 0.2 }} />
      <CircularProgress variant={'determinate'} value={Math.max(0, Math.min(100, value))} size={size}
                        thickness={thickness} sx={{ color }} />
      <Box sx={{ inset: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Stack alignItems={'center'}>
          <Typography data-test={'qa-score-ring-value'} variant={'h1'} sx={{ color, lineHeight: 1 }}>{value}%</Typography>
          {label && <Typography variant={'caption'} color={'text.secondary'}>{label}</Typography>}
        </Stack>
      </Box>
    </Box>
  );
};

// A score % rendered in its band color (for tables/cells).
export const ScoreText = ({ score, ...props }: { score?: number | null } & React.ComponentProps<typeof Typography>) => (
  <Typography data-test={'qa-score-text'} component={'span'} sx={{ color: scoreColor(score), fontWeight: 700 }} {...props}>
    {score == null ? '-' : `${Math.round(score)}%`}
  </Typography>
);